export const supportedResourcesData = [
    {
       name: "Patient",
       values: [
           {
               type: "link",
               value: "patient"
           },
           {
               type: "text",
               value: "Maps the Elevance Health Patient concept, merging all the patients in the same RecordGroup. The FHIR id is RecordGroup.PersonID"
           },
           {
               type: "text",
               value: "Read & Write"
           }
       ]
    }
]

export const supportedResourcesColumns = ["Resource Name", "Description", "Access"]

export const supportedResourcesDetailsData = [
    {
        name: "patient",
        description: "Maps the Elevance Health Patient concept, merging all the patients in the same RecordGroup. The FHIR id is RecordGroup.PersonID",
        supportedInteractions: ["read", "search", "create", "update", "delete"],          
        searchParameters: [
            {
                values: [
                {
                    type: "text",
                    value: "_id"
                },
                {
                    type: "text",
                    value: "Token"
                },
                {
                    type: "text",
                    value: ""
                },
                {
                    type: "text",
                    value: "Yes"
                },
                {
                    type: "text",
                    value: ""
                },
                {
                    type: "text",
                    value: "Resource id"
                },
             ]
            },
            {
                values: [
                {
                    type: "text",
                    value: "_source"
                },
                {
                    type: "text",
                    value: "Uri"
                },
                {
                    type: "text",
                    value: ":missing"
                },
                {
                    type: "text",
                    value: "Yes"
                },
                {
                    type: "text",
                    value: ""
                },
                {
                    type: "text",
                    value: "Where the resource comes from"
                },
             ]
            },
            {
                values: [
                {
                    type: "text",
                    value: "address"
                },
                {
                    type: "text",
                    value: "String"
                },
                {
                    type: "text",
                    value: ":contains :exact :missing"
                },
                {
                    type: "text",
                    value: "Yes"
                },
                {
                    type: "text",
                    value: ""
                },
                {
                    type: "text",
                    value: "An address in any kind of address/part of the patient"
                },
             ]
            }
        ],
        sorts : ['_id',
            'address',
            'address-city',
            'address-country',
            'address-postalcode',
            'address-state',
            'birthdate',
            'family',
            'given',
            'name',
            'telecom'
        ],
        includeItems: [
            'provenance-agent',
'AllergyIntolerance:patient',
'AuditEvent:patient',
'CarePlan:patient',
'CarePlan:subject',
'Claim:patient',
'Condition:patient',
'Condition:subject',
'Coverage:patient',
'Device:patient',
'DiagnosticOrder:patient',
'DiagnosticOrder:subject',
'DiagnosticReport:patient',
'DiagnosticReport:subject',
'DocumentManifest:patient',
'DocumentManifest:subject',
'DocumentReference:patient',
'DocumentReference:subject',
'Encounter:patient',
'Goal:patient',
'Goal:subject',
'Group:member',
'Immunization:patient',
'MedicationAdministration:patient',
'MedicationDispense:patient',
'MedicationOrder:patient',
'MedicationStatement:patient',
'Observation:patient',
'Observation:subject',
'Person:link',
'Person:relatedpatient',
'Procedure:patient',
'Procedure:subject',
'ProcedureRequest:patient',
'ProcedureRequest:subject',
'Provenance:target',
'ReferralRequest:patient',
'RelatedPerson:patient',
'Specimen:patient',
'Specimen:subject'
        ]
    }
]


export const supportedResourceDetailsDataScript = [{
    "name": "Binary",
    "description": "Maps the Elevance Health Report, LabReport, DemographicPicture concepts",
    "supportedInteractions": [
        "read"
    ],
    "searchParameters": [],
    "sorts": [
        "Provenance:target"
    ],
    "includeItems": [],
    "operations": []
},
{
    "name": "AuditEvent",
    "description": "Maps the Elevance Health AuditLogEntry concept",
    "supportedInteractions": [
        "read",
        "search"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Person)"
                },
                {
                    "type": "text",
                    "value": ":identifier"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The agent associated with the AuditEvent.\nThis is a special reference search parameter that only works with the :identifier modifier.\nThe identifier value must correspond to an identifier supplied with the AuditEvent.agent reference to match."
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "agent-name"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The name of an agent associated with the AuditEvent - path 'AuditEvent.agent.name'.\nMatches Elevance Health username or application names associated to the audit event."
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "date"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Time when the event was recorded"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "message"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Searches for audit events by their message"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the AuditEvent is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "subtype"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "More specific type/id for the event"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "type"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Type/identifier of event"
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "date"
    ],
    "includeItems": [
        "agent",
        "patient",
        "Provenance:target"
    ],
    "operations": []
},
{
    "name": "Organization",
    "description": "Maps Elevance Health RecordAuthority and its associated RecordAuthoritySubsets",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "lt\n                                le\n                                gt\n                                ge"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "endpoint"
                },
                {
                    "type": "text",
                    "value": "Reference (Endpoint)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Endpoint (Elevance Health Feed) references for the Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "identifier"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Any identifier for the organization (not the accreditation issuer's identifier)"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "name"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A portion of the organization's name or alias"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "type"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A code for the type of organization"
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "identifier"
    ],
    "includeItems": [
        "endpoint",
        "AllergyIntolerance:provenance-agent",
        "Basic:provenance-agent",
        "CarePlan:provenance-agent",
        "CareTeam:provenance-agent",
        "Claim:provenance-agent",
        "Condition:provenance-agent",
        "Coverage:provenance-agent",
        "DiagnosticReport:provenance-agent",
        "DocumentReference:provenance-agent",
        "Encounter:provenance-agent",
        "ExplanationOfBenefit:provenance-agent",
        "Goal:provenance-agent",
        "Immunization:provenance-agent",
        "MedicationAdministration:provenance-agent",
        "MedicationDispense:provenance-agent",
        "MedicationRequest:provenance-agent",
        "Observation:provenance-agent",
        "Patient:provenance-agent",
        "Practitioner:provenance-agent",
        "Procedure:provenance-agent",
        "Provenance:target",
        "ServiceRequest:provenance-agent",
        "Specimen:provenance-agent",
        "Task:provenance-agent"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
},
{
    "name": "Location",
    "description": "Maps the Elevance Health Location concept",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A (part of the) address of the location"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-city"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A city specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-country"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A country specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-postalcode"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A postal code specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-state"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A state specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "identifier"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "An identifier for the location"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "name"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A portion of the location's name or alias"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "type"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A code for the type of location"
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "identifier",
        "name",
        "type"
    ],
    "includeItems": [
        "Encounter:location",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
},
{
    "name": "AllergyIntolerance",
    "description": "Maps the Elevance Health Allergy concept",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "lt\n                                le\n                                gt\n                                ge"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "category"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "food | medication | environment | biologic"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "clinical-status"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "active | inactive | resolved"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "code"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Code that identifies the allergy or intolerance"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "criticality"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "low | high | unable-to-assess"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "date"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Date first version of the resource instance was recorded"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "encounter"
                },
                {
                    "type": "text",
                    "value": "Reference (Encounter)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "See here"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "manifestation"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Clinical symptoms/signs associated with the Event"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "onset"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Date(/time) when manifestations showed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the AllergyIntolerance is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "recorder"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Who recorded the sensitivity"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "type"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "allergy | intolerance - Underlying mechanism (if known)"
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "date"
    ],
    "includeItems": [
        "encounter",
        "patient",
        "provenance-agent",
        "recorder",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
},
{
    "name": "CarePlan",
    "description": "Maps CarePlan Elevance Health CareTaskGroup concepts, i.e. those CareTaskGroups with a CareTaskRuleType Term mapped to the Elevance Health CareTaskRuleType Term:'CarePlan' Or any CareTaskRuleType Term with Code equal to 'Goal'.",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "activity-reference"
                },
                {
                    "type": "text",
                    "value": "Reference (Task)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Activity details defined in specific resource"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "category"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Type of plan"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "date"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Time period plan covers"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "goal"
                },
                {
                    "type": "text",
                    "value": "Reference (Goal)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Desired outcome of plan"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "intent"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "proposal | plan | order | option"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the CarePlan is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "status"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "draft | active | on-hold | revoked | completed | entered-in-error | unknown"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "subject"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the CarePlan is about. Functionally identical to the \"patient\" search parameter."
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "date"
    ],
    "includeItems": [
        "activity-reference",
        "goal",
        "patient",
        "provenance-agent",
        "subject",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
},
{
    "name": "Endpoint",
    "description": "Maps read-only Elevance Health Feed concepts.",
    "supportedInteractions": [
        "read",
        "search"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "connection-type"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Protocol/Profile/Standard to be used with this endpoint connection"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "identifier"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Identifies this endpoint across multiple systems"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "name"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A name that this endpoint can be identified by"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "scope"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "See here"
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "connection-type",
        "name"
    ],
    "includeItems": [
        "Organization:endpoint",
        "Provenance:target"
    ],
    "operations": []
},
{
    "name": "Goal",
    "description": "Maps goal Elevance Health CareTask concepts, i.e. those caretasks with a category term code equal to 'Goal'.",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "category"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "E.g. Treatment, dietary, behavioral, etc."
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "date"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Search by due date"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "lifecycle-status"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "proposed | planned | accepted | active | on-hold | completed | cancelled | entered-in-error | rejected"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Goal is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "start-date"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When goal pursuit begins"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "subject"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Goal is about. Functionally identical to the \"patient\" search parameter."
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "target-date"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Reach goal on or before"
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "target-date"
    ],
    "includeItems": [
        "patient",
        "provenance-agent",
        "subject",
        "CarePlan:goal",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
},
{
    "name": "Person",
    "description": "Maps the Elevance Health UserInfo concept",
    "supportedInteractions": [
        "read",
        "search"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A server defined search that may match any of the string fields in the Address, including line, city, district, state, country, postalCode, and/or text"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-city"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A city specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-country"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A country specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-postalcode"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A postal code specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-state"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A state specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "birthdate"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The person's date of birth"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "gender"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The gender of the person"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "identifier"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A person Identifier"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "link"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Person is about. Functionally identical to the \"patient\" search parameter."
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "name"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A server defined search that may match any of the string fields in the HumanName, including family, give, prefix, suffix, suffix, and/or text"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "relatedpatient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Person is about. Functionally identical to the \"patient\" search parameter."
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "telecom"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The value in any kind of contact"
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "address",
        "address-city",
        "address-country",
        "address-postalcode",
        "address-state",
        "identifier",
        "name",
        "telecom"
    ],
    "includeItems": [
        "link",
        "relatedpatient",
        "AuditEvent:agent",
        "Provenance:target"
    ],
    "operations": []
},
{
    "name": "ValueSet",
    "description": "Maps the Elevance Health TermSubset concept",
    "supportedInteractions": [
        "read",
        "search"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "lt\n                                le\n                                gt\n                                ge"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "name"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Computationally friendly name of the value set"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "reference-concept"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A code included in the value set"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "version"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The business version of the value set"
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "name"
    ],
    "includeItems": [
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "available-versions",
            "href": "internal",
            "description": "- "
        },
        {
            "linkValue": "classify",
            "href": "internal",
            "description": "- "
        }
    ]
},
{
    "name": "Patient",
    "description": "Maps the Elevance Health Patient concept, merging all the patients in the same RecordGroup. The FHIR id is RecordGroup.PersonID",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A server defined search that may match any of the string fields in the Address, including line, city, district, state, country, postalCode, and/or text"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-city"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A city specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-country"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A country specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-postalcode"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A postalCode specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-state"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A state specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "age"
                },
                {
                    "type": "text",
                    "value": "Number"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                lt\n                                le\n                                gt\n                                ge"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Searches for patients based on age as calculated based on current date and date of birth. Deceased patients are excluded from the search."
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "birthdate"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The patient's date of birth"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "ethnicity"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Returns patients with an ethnicity extension matching the specified code."
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "family"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A portion of the family name of the patient"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "gender"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Gender of the patient"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "given"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A portion of the given name of the patient"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "identifier"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A patient identifier"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "language"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Language code (irrespective of use value)"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "name"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A server defined search that may match any of the string fields in the HumanName, including family, give, prefix, suffix, suffix, and/or text"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "race"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Returns patients with a race extension matching the specified code."
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "telecom"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The value in any kind of telecom details of the patient"
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "address",
        "address-city",
        "address-country",
        "address-postalcode",
        "address-state",
        "birthdate",
        "family",
        "given",
        "name",
        "telecom"
    ],
    "includeItems": [
        "provenance-agent",
        "AllergyIntolerance:patient",
        "AuditEvent:patient",
        "Basic:patient",
        "Basic:subject",
        "CarePlan:patient",
        "CarePlan:subject",
        "CareTeam:patient",
        "CareTeam:subject",
        "Claim:patient",
        "Condition:patient",
        "Condition:subject",
        "Coverage:beneficiary",
        "Coverage:patient",
        "Device:patient",
        "DiagnosticReport:patient",
        "DiagnosticReport:subject",
        "DocumentReference:patient",
        "DocumentReference:subject",
        "Encounter:patient",
        "ExplanationOfBenefit:patient",
        "FamilyMemberHistory:patient",
        "Goal:patient",
        "Goal:subject",
        "Group:member",
        "Immunization:patient",
        "MedicationAdministration:patient",
        "MedicationAdministration:subject",
        "MedicationDispense:patient",
        "MedicationDispense:subject",
        "MedicationRequest:patient",
        "MedicationRequest:subject",
        "Observation:patient",
        "Observation:subject",
        "Person:link",
        "Person:relatedpatient",
        "Procedure:patient",
        "Procedure:subject",
        "Provenance:target",
        "RelatedPerson:patient",
        "ServiceRequest:patient",
        "ServiceRequest:subject",
        "Specimen:patient",
        "Specimen:subject",
        "Task:patient",
        "Task:subject"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        },
        {
            "linkValue": "everything",
            "href": "internal",
            "description": "- Fetch Patient Record"
        },
        {
            "linkValue": "accumulators",
            "href": "internal",
            "description": "- Get claim accumulators"
        },
        {
            "linkValue": "office-visits",
            "href": "internal",
            "description": "- Get office visits claims and service requests"
        },
        {
            "linkValue": "inpatient",
            "href": "internal",
            "description": "- Get inpatient claims and service requests"
        },
        {
            "linkValue": "emergency-department",
            "href": "internal",
            "description": "- Get emergency department claims and service requests"
        },
        {
            "linkValue": "visits",
            "href": "internal",
            "description": "- Categorized inpatient and outpatient visits"
        },
        {
            "linkValue": "match",
            "href": "internal",
            "description": "- Patient Match"
        }
    ]
},
{
    "name": "Condition",
    "description": "Combines the Elevance Health Problem, ClaimProblem, and ReferralProblem concepts",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "lt\n                                le\n                                gt\n                                ge"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "asserter"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Person who asserts this condition"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "category"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The category of the condition"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "claim"
                },
                {
                    "type": "text",
                    "value": "Reference (Claim)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Searches for conditions by their associated claim"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "clinical-status"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The clinical status of the condition"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "code"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Code for the condition"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "encounter"
                },
                {
                    "type": "text",
                    "value": "Reference (Encounter)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Encounter created as part of"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "explanation-of-benefit"
                },
                {
                    "type": "text",
                    "value": "Reference (ExplanationOfBenefit)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Searches for conditions by their associated explanation of benefit"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "onset-date"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Date related onsets (dateTime and Period)"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Condition is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "referral"
                },
                {
                    "type": "text",
                    "value": "Reference (Basic)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Searches for conditions by their associated referral"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "subject"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Condition is about. Functionally identical to the \"patient\" search parameter."
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "onset"
    ],
    "includeItems": [
        "asserter",
        "claim",
        "encounter",
        "explanation-of-benefit",
        "patient",
        "provenance-agent",
        "referral",
        "subject",
        "Encounter:diagnosis",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
},
{
    "name": "Task",
    "description": "Maps task Elevance Health CareTask concepts, i.e. those caretasks category term mapped to 'To Do'.",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "lt\n                                le\n                                gt\n                                ge"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "authored-on"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Search by creation date"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "code"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Search by task code"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "modified"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Search by last modification date"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "owner"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by task owner"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Task is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "period"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Search by period Task is/was underway"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "priority"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Search by task priority"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "status"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Search by task status"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "subject"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Task is about. Functionally identical to the \"patient\" search parameter."
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "lastModified"
    ],
    "includeItems": [
        "owner",
        "patient",
        "provenance-agent",
        "subject",
        "CarePlan:activity-reference",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
},
{
    "name": "Device",
    "description": "Maps Elevance Health DeviceDataSource concept describing devices.",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Device is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "type"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The type of the device"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "udi-carrier"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "UDI Barcode (RFID or other technology) string in HRF format."
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "udi-di"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The udi Device Identifier (DI)"
                }
            ]
        }
    ],
    "sorts": [
        "_id"
    ],
    "includeItems": [
        "patient",
        "Observation:device",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
},
{
    "name": "DiagnosticReport",
    "description": "Combines the Elevance Health Report and LabReport concepts",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "basedOn"
                },
                {
                    "type": "text",
                    "value": "Reference (ServiceRequest)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "See here"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "category"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The classification of the type of report - path DiagnosticReport.category.\nMatches Elevance Health reports whose type is in a term subset with scope 'http://loinc.org' and name equal to one of the specified codes with system 'http://loinc.org'.\nMatches any Elevance Health lab reports if one of the specified category codes is 'LAB' with system 'http://terminology.hl7.org/CodeSystem/v2-0074'.\nSo for example 'category=http://loinc.org|LP7839-6' (and 'category=Pathology') matches no lab reports and matches reports whose type is in the term subset with scope 'http://loinc.org' and name 'LP7839-6'.\n'category=http://terminology.hl7.org/CodeSystem/v2-0074|LAB' (and 'category=LAB') matches any lab report whose type is in the term subset with scope 'http://terminology.hl7.org/CodeSystem/v2-0074' and name 'LAB'.\n'category=http://snomed.info/sct|laboratory' matches no lab reports and matches no reports."
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "code"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The code for the report, as opposed to codes for the atomic results, which are the names on the observation resource referred to from the result"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "date"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The clinically relevant time of the report"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "encounter"
                },
                {
                    "type": "text",
                    "value": "Reference (Encounter)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The Encounter when the order was made"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the DiagnosticReport is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "performer"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Who is responsible for the report"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "result"
                },
                {
                    "type": "text",
                    "value": "Reference (Observation)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Link to an atomic result (observation resource)"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "specimen"
                },
                {
                    "type": "text",
                    "value": "Reference (Specimen)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The specimen details"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "status"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The status of the report"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "subject"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the DiagnosticReport is about. Functionally identical to the \"patient\" search parameter."
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "date"
    ],
    "includeItems": [
        "basedOn",
        "encounter",
        "patient",
        "performer",
        "provenance-agent",
        "result",
        "specimen",
        "subject",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        },
        {
            "linkValue": "text-search",
            "href": "internal",
            "description": "- Search Report Text"
        }
    ]
},
{
    "name": "Practitioner",
    "description": "Maps the Elevance Health Caregiver concept",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A server defined search that may match any of the string fields in the Address, including line, city, district, state, country, postalCode, and/or text"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-city"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A city specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-country"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A country specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-postalcode"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A postalCode specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-state"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A state specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "birthdate"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "See here"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "family"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A portion of the family name"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "gender"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Gender of the practitioner"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "given"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A portion of the given name"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "identifier"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A practitioner's Identifier"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "language"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "See here"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "name"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A server defined search that may match any of the string fields in the HumanName, including family, give, prefix, suffix, suffix, and/or text"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "role"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "See here"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "telecom"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The value in any kind of contact"
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "address",
        "address-city",
        "address-country",
        "address-postalcode",
        "address-state",
        "family",
        "given",
        "name",
        "telecom"
    ],
    "includeItems": [
        "provenance-agent",
        "AllergyIntolerance:recorder",
        "Basic:referFrom",
        "Basic:referFromFacility",
        "Basic:referTo",
        "Basic:referToFacility",
        "Claim:provider",
        "Condition:asserter",
        "DiagnosticReport:performer",
        "DocumentReference:authenticator",
        "DocumentReference:author",
        "Encounter:practitioner",
        "ExplanationOfBenefit:care-team",
        "ExplanationOfBenefit:provider",
        "Immunization:performer",
        "MedicationAdministration:performer",
        "MedicationDispense:performer",
        "MedicationDispense:responsibleparty",
        "MedicationRequest:requester",
        "Observation:performer",
        "Procedure:performer",
        "Provenance:target",
        "ServiceRequest:requester",
        "Task:owner"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
},
{
    "name": "MedicationAdministration",
    "description": "Maps Elevance Health MedicationAdministration concepts that are not immunization, i.e. those with an AdminMethod term code different from 'Immunization Tag'\nThe mapping includes also the MedicationProfile concept associated with each MedicationAdministration.",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "lt\n                                le\n                                gt\n                                ge"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "code"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Return administrations of this medication code"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "context"
                },
                {
                    "type": "text",
                    "value": "Reference (Encounter)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Associated encounter"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "effective-time"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Date administration happened (or did not happen)"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "encounter"
                },
                {
                    "type": "text",
                    "value": "Reference (Encounter)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Associated encounter"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "not-given"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "See here"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the MedicationAdministration is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "performer"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The identity of the individual who administered the medication"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "request"
                },
                {
                    "type": "text",
                    "value": "Reference (MedicationRequest)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The identity of a request to list administrations from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "status"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "MedicationAdministration event status (for example one of active/paused/completed/nullified)"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "subject"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the MedicationAdministration is about. Functionally identical to the \"patient\" search parameter."
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "effective-time"
    ],
    "includeItems": [
        "context",
        "encounter",
        "patient",
        "performer",
        "provenance-agent",
        "request",
        "subject",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
},
{
    "name": "RelatedPerson",
    "description": "Maps the Elevance Health PatientAssociatedParty concept",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "lt\n                                le\n                                gt\n                                ge"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A server defined search that may match any of the string fields in the Address, including line, city, district, state, country, postalCode, and/or text"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-city"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A city specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-country"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A country specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-postalcode"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A postal code specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "address-state"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A state specified in an address"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "birthdate"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The Related Person's date of birth"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "gender"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Gender of the related person"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "name"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A server defined search that may match any of the string fields in the HumanName, including family, give, prefix, suffix, suffix, and/or text"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the RelatedPerson is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "telecom"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The value in any kind of contact"
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "address",
        "address-city",
        "address-country",
        "address-postalcode",
        "address-state",
        "name",
        "telecom"
    ],
    "includeItems": [
        "patient",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
},
{
    "name": "Group",
    "description": "Maps the Elevance Health PatientGroup, PatientGroupMember concepts",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "code"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The kind of resources contained"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "identifier"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Unique id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "member"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Group is about. Functionally identical to the \"patient\" search parameter."
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "name"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Searches for groups by their name"
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "name"
    ],
    "includeItems": [
        "member",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        },
        {
            "linkValue": "getPage",
            "href": "internal",
            "description": "- Gets a group paging through its members"
        },
        {
            "linkValue": "add",
            "href": "internal",
            "description": "- Adds members to a group"
        },
        {
            "linkValue": "remove",
            "href": "internal",
            "description": "- Remove members from a group"
        }
    ]
},
{
    "name": "MedicationRequest",
    "description": "Maps pharmacy Elevance Health Order concepts, i.e. those orders with a Department term code equal to 'Pharmacy'",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "lt\n                                le\n                                gt\n                                ge"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "authoredon"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Return prescriptions written on this date"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "code"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Return prescriptions of this medication code"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "encounter"
                },
                {
                    "type": "text",
                    "value": "Reference (Encounter)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Multiple Resources:\n\nMedicationRequest: Return prescriptions with this encounter identifier"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "identifier"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Return prescriptions with this external identifier"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "intent"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Returns prescriptions with different intents"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the MedicationRequest is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "requester"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Returns prescriptions prescribed by this prescriber"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "status"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Status of the prescription"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "subject"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the MedicationRequest is about. Functionally identical to the \"patient\" search parameter."
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "authoredon"
    ],
    "includeItems": [
        "encounter",
        "patient",
        "provenance-agent",
        "requester",
        "subject",
        "MedicationAdministration:request",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
},
{
    "name": "Procedure",
    "description": "Combines the Elevance Health Procedure and ClaimProcedure concepts",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "claim"
                },
                {
                    "type": "text",
                    "value": "Reference (Claim)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Searches for procedures by their associated claim"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "code"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A code to identify a  procedure"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "date"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the procedure was performed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "encounter"
                },
                {
                    "type": "text",
                    "value": "Reference (Encounter)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Encounter created as part of"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "explanation-of-benefit"
                },
                {
                    "type": "text",
                    "value": "Reference (ExplanationOfBenefit)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Searches for procedures by their associated explanation of benefit"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Procedure is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "performer"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The reference to the practitioner"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "status"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "preparation | in-progress | not-done | on-hold | stopped | completed | entered-in-error | unknown"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "subject"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Procedure is about. Functionally identical to the \"patient\" search parameter."
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "date"
    ],
    "includeItems": [
        "claim",
        "encounter",
        "explanation-of-benefit",
        "patient",
        "performer",
        "provenance-agent",
        "subject",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
},
{
    "name": "MedicationDispense",
    "description": "Maps the Elevance Health Medication concept",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "claim"
                },
                {
                    "type": "text",
                    "value": "Reference (Claim)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Searches for MedicationDispense by referenced claim id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "code"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Returns dispenses of this medicine code"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "context"
                },
                {
                    "type": "text",
                    "value": "Reference (Encounter)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Searches for medication dispense by their associated encounter"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "explanation-of-benefit"
                },
                {
                    "type": "text",
                    "value": "Reference (ExplanationOfBenefit)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Searches for MedicationDispense by referenced claim id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the MedicationDispense is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "performer"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Returns dispenses performed by a specific individual"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "responsibleparty"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Returns dispenses with the specified responsible party"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "subject"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the MedicationDispense is about. Functionally identical to the \"patient\" search parameter."
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "whenhandedover"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Returns dispenses handed over on this date"
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "whenhandedover"
    ],
    "includeItems": [
        "claim",
        "context",
        "explanation-of-benefit",
        "patient",
        "performer",
        "provenance-agent",
        "responsibleparty",
        "subject",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
},
{
    "name": "Coverage",
    "description": "Maps the Elevance Health Insurance concept",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "beneficiary"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Coverage is about. Functionally identical to the \"patient\" search parameter."
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "dependent"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Dependent number"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "group"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "See here"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "identifier"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The primary identifier of the insured and the coverage"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Coverage is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "plan"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "See here"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "sequence"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "See here"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "subplan"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "See here"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "type"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The kind of coverage (health plan, auto, Workers Compensation)"
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "plan",
        "type"
    ],
    "includeItems": [
        "beneficiary",
        "patient",
        "provenance-agent",
        "ExplanationOfBenefit:coverage",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
},
{
    "name": "Observation",
    "description": "Combines the Elevance Health Observation, LabObservation, DeviceDataContextWithDeviceDataPoints, and DeviceDataPoint concepts",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            lt\n                                le\n                                gt\n                                ge"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "category"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The classification of the type of observation - path Observation.category.\nMatches Elevance Health observations whose type is in a term subset with scope 'http://terminology.hl7.org/CodeSystem/observation-category' and name equal to one of the specified codes with system 'http://terminology.hl7.org/CodeSystem/observation-category'.\nMatches any Elevance Health lab observations if one of the specified category codes is 'laboratory' with system 'http://terminology.hl7.org/CodeSystem/observation-category'.\nSo for example 'category=http://terminology.hl7.org/CodeSystem/observation-category|vital-signs' (and 'category=vital-signs') matches no lab observation and matches observations whose type is in the term subset with scope 'http://terminology.hl7.org/CodeSystem/observation-category' and name 'vital-signs';\n'category=http://terminology.hl7.org/CodeSystem/observation-category|laboratory' (and 'category=laboratory') matches any lab observation and no observations. Observations whose type is in the term subset with scope 'http://terminology.hl7.org/CodeSystem/observation-category' and name 'laboratory' are always excluded and 'category=http://snomed.info/sct|laboratory' matches no lab observation or observations. R4 version also includes all Elevance Health device data."
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "code"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The code of the observation type"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "date"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Obtained date/time. If the obtained element is a period, a date that falls in the period"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "device"
                },
                {
                    "type": "text",
                    "value": "Reference (Device)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The Device that generated the observation data."
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "document-date"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Searches for observation by their associated document date"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "document-type"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Searches for observation by their associated document type"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "encounter"
                },
                {
                    "type": "text",
                    "value": "Reference (Encounter)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Encounter related to the observation"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Observation is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "performer"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Who performed the observation"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "status"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The status of the observation"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "subject"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Observation is about. Functionally identical to the \"patient\" search parameter."
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "date"
    ],
    "includeItems": [
        "device",
        "encounter",
        "patient",
        "performer",
        "provenance-agent",
        "subject",
        "DiagnosticReport:result",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
},
{
    "name": "Immunization",
    "description": "Maps Elevance Health MedicationAdministration concepts that are immunization, i.e. those with an AdminMethod term code equal to 'Immunization Tag'\nThe mapping includes also the MedicationProfile concept associated with each MedicationAdministration.\nThe mapping does not include any claim service or medication because the immunization service codes term subset is not defined in the configuration",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "lt\n                                le\n                                gt\n                                ge"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "claim"
                },
                {
                    "type": "text",
                    "value": "Reference (Claim)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Searches for immunizations by their associated claim"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "date"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Vaccination  (non)-Administration Date"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "encounter"
                },
                {
                    "type": "text",
                    "value": "Reference (Encounter)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Searches for immunizations by their associated encounter"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "explanation-of-benefit"
                },
                {
                    "type": "text",
                    "value": "Reference (ExplanationOfBenefit)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Searches for immunizations by their associated explanation of benefit"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "lot-number"
                },
                {
                    "type": "text",
                    "value": "String"
                },
                {
                    "type": "text",
                    "value": ":contains\n                                :exact\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Vaccine Lot Number"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Immunization is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "performer"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The practitioner or organization who played a role in the vaccination"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "reason-code"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Reason why the vaccine was administered"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "status"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Immunization event status"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "vaccine-code"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Vaccine Product Administered"
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "date"
    ],
    "includeItems": [
        "claim",
        "encounter",
        "explanation-of-benefit",
        "patient",
        "performer",
        "provenance-agent",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
},
{
    "name": "Specimen",
    "description": "Maps the Elevance Health LabReportSpecimen, LabReport concepts",
    "supportedInteractions": [
        "read",
        "search",
        "create"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "bodysite"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The code for the body site from where the specimen originated"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "date"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "See here"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "encounter"
                },
                {
                    "type": "text",
                    "value": "Reference (Encounter)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Searches for specimens by their associated encounter"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "identifier"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The unique identifier associated with the specimen"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Specimen is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "subject"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Specimen is about. Functionally identical to the \"patient\" search parameter."
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "type"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The specimen type"
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "identifier"
    ],
    "includeItems": [
        "encounter",
        "patient",
        "provenance-agent",
        "subject",
        "DiagnosticReport:specimen",
        "Provenance:target"
    ],
    "operations": []
},
{
    "name": "Encounter",
    "description": "Maps the Elevance Health Encounter, Problem concepts",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "lt\n                                le\n                                gt\n                                ge"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "admitdate"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Searches for encounters by admit date"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "class"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Classification of patient encounter"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "date"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "A date within the period the Encounter lasted"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "diagnosis"
                },
                {
                    "type": "text",
                    "value": "Reference (Condition)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The diagnosis or procedure relevant to the encounter"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "dischargedate"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Searches for encounters by discharge date"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "identifier"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Identifier(s) by which this encounter is known"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "location"
                },
                {
                    "type": "text",
                    "value": "Reference (Location)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Location the encounter takes place"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "participant-type"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Role of participant in encounter"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Encounter is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "practitioner"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Persons involved in the encounter other than the patient"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "reason-code"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Coded reason the encounter takes place"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "status"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "planned | arrived | triaged | in-progress | onleave | finished | cancelled +"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "type"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Specific type of encounter"
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "date"
    ],
    "includeItems": [
        "diagnosis",
        "location",
        "patient",
        "practitioner",
        "provenance-agent",
        "AllergyIntolerance:encounter",
        "Basic:encounter",
        "Claim:encounter",
        "Condition:encounter",
        "DiagnosticReport:encounter",
        "DocumentReference:encounter",
        "ExplanationOfBenefit:encounter",
        "FamilyMemberHistory:encounter",
        "Immunization:encounter",
        "MedicationAdministration:context",
        "MedicationAdministration:encounter",
        "MedicationDispense:context",
        "MedicationRequest:encounter",
        "Observation:encounter",
        "Procedure:encounter",
        "Provenance:target",
        "ServiceRequest:encounter",
        "Specimen:encounter"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        },
        {
            "linkValue": "classify-visits",
            "href": "internal",
            "description": "- Categorized inpatient and outpatient visits"
        }
    ]
},
{
    "name": "ServiceRequest",
    "description": "Combines the Elevance Health Referrals and non-pharmacy Order concepts, i.e. those orders with a Department term code different from 'Pharmacy'",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "authored"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Date request signed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "body-site"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where procedure is going to be done"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "code"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "What is being requested/ordered"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "encounter"
                },
                {
                    "type": "text",
                    "value": "Reference (Encounter)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "An encounter in which this request is made"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "identifier"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Identifiers assigned to this order"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "occurrence"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When service should occur"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the ServiceRequest is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "priority"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "routine | urgent | asap | stat"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "referral"
                },
                {
                    "type": "text",
                    "value": "Reference (Basic)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "See here"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "requester"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Who/what is requesting service"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "status"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "draft | active | on-hold | revoked | completed | entered-in-error | unknown"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "subject"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the ServiceRequest is about. Functionally identical to the \"patient\" search parameter."
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "authored"
    ],
    "includeItems": [
        "encounter",
        "patient",
        "provenance-agent",
        "referral",
        "requester",
        "subject",
        "DiagnosticReport:basedOn",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        },
        {
            "linkValue": "classify-visits",
            "href": "internal",
            "description": "- Categorized inpatient and outpatient visits"
        }
    ]
},
{
    "name": "Basic",
    "description": "Maps Elevance Health Referral concept to FHIR Basic resource with Elevance Health extensions.  Basic resource code property must contain code with system='http://terminology.hl7.org/CodeSystem/basic-resource-type' and code='referral'.",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "admissionPeriod"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Referral admission period"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "code"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Kind of Resource"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "encounter"
                },
                {
                    "type": "text",
                    "value": "Reference (Encounter)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Associated encounter"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "identifier"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Business identifier"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Basic is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "referFrom"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Referral from practitioner"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "referFromFacility"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Referral from facility"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "referralPeriod"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Referral period"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "referTo"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Referral to practitioner"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "referToFacility"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Referral to facility"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "status"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":not\n                                :in\n                                :not-in\n                                :missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Referral status"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "subject"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the Basic is about. Functionally identical to the \"patient\" search parameter."
                }
            ]
        }
    ],
    "sorts": [
        "_id"
    ],
    "includeItems": [
        "encounter",
        "patient",
        "provenance-agent",
        "referFrom",
        "referFromFacility",
        "referTo",
        "referToFacility",
        "subject",
        "Condition:referral",
        "Provenance:target",
        "ServiceRequest:referral"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
},
{
    "name": "ExplanationOfBenefit",
    "description": "Maps Elevance Health Claim  and contained Medication  concepts",
    "supportedInteractions": [
        "read",
        "search",
        "create",
        "update",
        "delete"
    ],
    "searchParameters": [
        {
            "values": [
                {
                    "type": "text",
                    "value": "_id"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Resource id"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_lastUpdated"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": "lt\n                                le\n                                gt\n                                ge"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "When the resource last changed"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "_source"
                },
                {
                    "type": "text",
                    "value": "Uri"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Where the resource comes from"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "care-team"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Member of the CareTeam"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "coverage"
                },
                {
                    "type": "text",
                    "value": "Reference (Coverage)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The plan under which the claim was adjudicated"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "created"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The creation date for the EOB"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "encounter"
                },
                {
                    "type": "text",
                    "value": "Reference (Encounter)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Encounters associated with a billed line item"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "identifier"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "The business identifier of the Explanation of Benefit"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "patient"
                },
                {
                    "type": "text",
                    "value": "Reference (Patient)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The patient the ExplanationOfBenefit is about"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provenance-agent"
                },
                {
                    "type": "text",
                    "value": "Reference (Organization)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Search by provenance, specified by its author (aka originator) Organization"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "provider"
                },
                {
                    "type": "text",
                    "value": "Reference (Practitioner)"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": "The reference to the provider"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "service-date"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Date of the service for the EOB"
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "service-start-date"
                },
                {
                    "type": "text",
                    "value": "Date"
                },
                {
                    "type": "text",
                    "value": ":missing\n                                                            eq\n                                ne\n                                lt\n                                le\n                                gt\n                                ge\n                                sa\n                                eb\n                                ap"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Starting Date of the service for the EOB."
                }
            ]
        },
        {
            "values": [
                {
                    "type": "text",
                    "value": "type"
                },
                {
                    "type": "text",
                    "value": "Token"
                },
                {
                    "type": "text",
                    "value": ":missing"
                },
                {
                    "type": "text",
                    "value": "Yes"
                },
                {
                    "type": "text",
                    "value": ""
                },
                {
                    "type": "text",
                    "value": "Claim type"
                }
            ]
        }
    ],
    "sorts": [
        "_id",
        "identifier"
    ],
    "includeItems": [
        "care-team",
        "coverage",
        "encounter",
        "patient",
        "provenance-agent",
        "provider",
        "Condition:explanation-of-benefit",
        "Immunization:explanation-of-benefit",
        "MedicationDispense:explanation-of-benefit",
        "Procedure:explanation-of-benefit",
        "Provenance:target"
    ],
    "operations": [
        {
            "linkValue": "validate",
            "href": "http://hl7.org/fhir/DSTU2/operation-resource-validate.html",
            "description": "- Validate a resource"
        }
    ]
}
]
  
  
